/**
 * ConnectionStatus - Display SSE connection status indicator.
 */

import type { JSX } from 'react';

interface ConnectionStatusProps {
  status: string;
}

export function ConnectionStatus({ status }: ConnectionStatusProps): JSX.Element {
  return (
    <div className="mb-4 flex items-center gap-2 text-xs pb-2 border-b border-default">
      <div
        className={`w-2 h-2 rounded-full ${
          status === 'connected'
            ? 'bg-success-500'
            : status === 'connecting'
              ? 'bg-warning-500 animate-pulse'
              : status === 'error'
                ? 'bg-danger-500'
                : 'bg-default-400'
        }`}
      />
      <span className="text-muted">
        {status === 'connected'
          ? 'Connected'
          : status === 'connecting'
            ? 'Connecting...'
            : status === 'error'
              ? 'Connection Error'
              : 'Disconnected'}
      </span>
    </div>
  );
}
